module.exports = __webpack_public_path__ + "assets/img/dc665228383f4a6fcb61398638060912.png";